import QRCode from "qrcode";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import Button from "../../components/Button";
import Gap from "../../components/Gap";
import Loading from "../../components/Loading";
import Navbar from "../../components/Navbar";
import { proses_data, send_email } from "../../config/config";
import FETCH_API from "../../config/fetch_api";
import { router } from "../../Constants";
import { showLog } from "../../utils/log";
import { socket } from "../../utils/socket";

function Barcode(params) {
  const location = useLocation();
  const state = location?.state;
  const { addToast } = useToasts();
  let navigate = useNavigate();
  const [imageUrl, setImageUrl] = useState("");
  const [checkPembayaran, setCheckPembayaran] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const userServer = JSON.parse(localStorage.getItem("userServer"));
  const [timeoutId, setTimeoutId] = useState(null);

  async function CekStatus() {
    showLog("Barcode Masuk CekStatus");
    const dataPeyment = state?.[0];
    const user = JSON.parse(localStorage.getItem("login"));
    const orderDate = JSON.parse(localStorage.getItem("orderDate"));
    const id = JSON.parse(localStorage.getItem("idpesanan"));
    const checkPayment = await FETCH_API("payment-gateway/checkSuccessXendit", {
      id: state[0]?.["external_id"],
      userServer: userServer,
    });
    const detailData = [];
    if (checkPayment["hasil"]["status"] == "ACTIVE") {
      setLoading(false);
      addToast("Pembayaran belum selesai", {
        appearance: "info",
        autoDismiss: true,
      });
    } else {
      try {
        const result = await proses_data();
        if (result.status == "OK") {
          send_email({
            subject: "Pembayaran Uruz",
            carabayar: "QR Code",
            idTransaksi: dataPeyment?.id,
            subTotal: dataPeyment?.amount,
            grandTotal: dataPeyment?.amount,
            linkLihatDetail: "https://google.com",
            detailData: detailData,
          });
          addToast("Pembayaran Berhasil", {
            appearance: "success",
            autoDismiss: true,
          });
          localStorage.removeItem("pesanan");
          navigate(`${router}/payment-succes`);
        }
      } catch (error) {
        showLog(`Barcode ${error}`);
      }
    }
  }

  useEffect(() => {
    showLog("Barcode Masuk useEffect 1");

    const handlePopstate = () => {
      navigate(`${router}/order`);
    };

    let checkTimer = null;

    const run = async () => {
      const response = await QRCode.toDataURL(state?.[0]?.qr_string);
      setImageUrl(response);
      checkTimer = setTimeout(() => {
        setCheckPembayaran(true);
      }, 10000);
    };

    run();
    window.addEventListener("popstate", handlePopstate);

    return () => {
      window.removeEventListener("popstate", handlePopstate);
      if (checkTimer) clearTimeout(checkTimer);
    };
  }, [navigate, state]);

  useEffect(() => {
    showLog("Barcode Masuk useEffect 2");
    // GojekStatus()
    // GojekUpdateStatus()

    let paymentTimer = null;

    const handleConnect = () => {
      showLog(`Socket Connected With ID = ${socket.id}`);
    };

    const handleConnectError = (err) => {
      showLog(`Socket Connect Error ${err}`);
    };

    const handlePaymentSuccess = (data) => {
      const orderDate = JSON.parse(localStorage.getItem("dataBranch"));
      const currentTransId = orderDate?.detailData;
      const incomingTransId =
        data?.trans_id ?? data?.transId ?? data?.transID ?? data?.id ?? data?.data?.trans_id;

      if (incomingTransId && currentTransId) {
        if (String(incomingTransId) !== String(currentTransId)) return;
      }

      showLog(
        `[socket:payment-success] incomingTransId=${incomingTransId} currentTransId=${currentTransId}`
      );

      if (paymentTimer) clearTimeout(paymentTimer);
      paymentTimer = setTimeout(() => {
        CekStatus();
      }, 3000);
      setTimeoutId(paymentTimer);
    };

    socket.on("connect", handleConnect);
    socket.on("connect_error", handleConnectError);
    socket.on("payment-success", handlePaymentSuccess);

    return () => {
      if (paymentTimer) clearTimeout(paymentTimer);
      socket.off("connect", handleConnect);
      socket.off("connect_error", handleConnectError);
      socket.off("payment-success", handlePaymentSuccess);
    };
  }, []);

  return (
    <div>
      <Navbar
        urlBack="/order"
        paramsUrlBack={{
          params: state?.["params"],
        }}
        type="back"
        label="Pembayaran QRIS"
      />
      <div style={{ paddingTop: "20%" }}>
        <div style={{ margin: "0 20px" }}>
          <div
            style={{ fontSize: 17, textAlign: "center" }}
            className="fonts600"
          >
            Buka aplikasi E-Wallet Anda dan Scan QR Code untuk membayar pesanan
            Anda
          </div>
          <Gap height={30} />
          <div
            style={{ color: "#5451D6", fontSize: 17, textAlign: "center" }}
            className="fonts700"
          >
            Pembayaran dapat dilakukan melalui OVO, DANA, LinkAja, ShopeePay dan
            Sakuku
          </div>
        </div>
        <div
          style={{
            justifyContent: "center",
            display: "grid",
            padding: "24px 0",
          }}
        >
          {imageUrl ? (
            <a href={imageUrl} download>
              <img
                style={{ width: 250, height: 250 }}
                src={imageUrl}
                alt="img"
              />
            </a>
          ) : (
            <Loading />
          )}
        </div>
        <div style={{ margin: "0 10%" }}>
          {checkPembayaran && (
            <Button
              onClick={() => {
                CekStatus();
                setLoading(true);
              }}
              loading={loading}
              color="#fff"
              backgroundColor="#5451D6"
            >
              Cek Pembayaran
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Barcode;
